module.exports = __webpack_public_path__ + "static/media/ic_ounter_white.4068e04a.svg";